module.exports = __webpack_public_path__ + "static/media/ic-fb.98ad8cb2.svg";